import { Link } from 'react-router-dom';
import { BsPencilSquare } from 'react-icons/bs';
import { GTMsendEvent } from '../../utils/trackingGA4'
import { translateRoles } from '../../utils/translations';
import i18next from 'i18next';

export const columnsData = [
	{
		accessor: 'username',
		id: 'username',
		Header: i18next.t('username'),
		minWidth: 290,
	},
	{
		accessor: 'given_name',
		id: 'given_name',
		Header: i18next.t('name'),
		width: 120,
	},
	{
		accessor: 'family_name',
		id: 'family_name',
		Header: i18next.t('surname'),
		width: 140,
	},
	{
		accessor: 'role',
		id: 'role',
		Header: i18next.t('role'),
		width: 120,
		Cell: (data: any) => (
			<div>{translateRoles(data.value)}</div>
		),
	},
	{
		id: 'dealer',
		Header: i18next.t('dealer_filiale'),
		width: 120,
		accessor: (values) => {
			const list = values?.reference_partner || [];
			return list?.[0];
    },
		Cell: ({ row }) => {
			const list = row.original?.reference_partner || [];
			const refPartner = list[0];
			return (<div>{refPartner || ''}</div>);
		},
	},
	{
		accessor: 'phone',
		id: 'phone',
		Header: i18next.t('phone'),
		width: 120,
	},
	// {
	// 	accessor: 'phone_backup',
	// 	id: 'phone_backup',
	// 	Header: i18next.t('phone_backup'),
	// 	width: 150,
	// },
	// {
	// 	accessor: 'email_backup',
	// 	id: 'email_backup',
	// 	Header: i18next.t('email_backup'),
	// 	width: 290,
	// },
	{
		accessor: 'actions',
		id: 'actions',
		Header: '',
		disableSortBy: true,
		headerClassName: 'column-sticky',
		className: 'column-sticky',
		width: 60,
		Cell: (data: any) => (
			<Link
			 to={`/manage-users/${data.row.original.username}`}
			 className="btn"
			 onClick={() => {
				GTMsendEvent({
					event: 'CTA_modify_user',
					evtCat: 'user',
					evtAct: 'modify',
					evtLab: `modify_user`
				})
			 }}
			 >
				<BsPencilSquare
					style={{ width: '1.2rem', height: '1.6rem' }}
					name="edit"
				/>
			</Link>
		),
	},
];
